











import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { SelectOptionData } from '../../../../components/Pi/types'

@Component
export default class TopicCard extends Vue {
  @Prop() item!:SelectOptionData
}
